import { z } from 'zod';

export const TransformUniqueValuesByColumnItem = z.object({
  columnName: z.string(),
  uniqueValues: z.array(z.string()),
});

export type TransformUniqueValuesByColumnItem = z.infer<
  typeof TransformUniqueValuesByColumnItem
>;

export const TransformPossibleDimension = z.object({
  name: z.string(),
  values: z.array(z.string()),
});

export type TransformPossibleDimension = z.infer<
  typeof TransformPossibleDimension
>;

export const TransformInsightsNumericColumn = z.object({
  minValue: z.number(),
  maxValue: z.number(),
  isInteger: z.boolean(),
  anyBlanks: z.boolean(),
});

export type TransformInsightsNumericColumn = z.infer<
  typeof TransformInsightsNumericColumn
>;

export const TransformInsightsDateColumn = z.object({
  minValue: z.string(),
  maxValue: z.string(),
  anyBlanks: z.boolean(),
});

export type TransformInsightsDateColumn = z.infer<
  typeof TransformInsightsDateColumn
>;

export const TransformInsights = z.object({
  requiredVisibleColumns: z.array(z.string()),
  desiredVisibleColumns: z.array(z.string()),
  optionalVisibleColumns: z.array(z.string()),
  customVisibleColumns: z.array(z.string()),
  desiredMissingColumns: z.array(z.string()),
  optionalMissingColumns: z.array(z.string()),
  possibleDimensionColumns: z.array(TransformPossibleDimension),
  possibleMetricColumns: z.array(z.string()),
  uniqueValuesByColumn: z.array(TransformUniqueValuesByColumnItem),
  departmentToJobTitleColumnValues: z
    .record(z.string(), z.array(z.string()))
    .optional(),

  /**
   * The columns that are numeric (scalar) columns
   *
   * For example, any number is considered a scalar column
   */
  numericColumns: z
    .record(z.string(), TransformInsightsNumericColumn)
    .optional(),

  /**
   * The columns that are date columns
   *
   * A column is a date column if all values in the column are dates (ie: 2021-04-01)
   */
  dateColumns: z.record(z.string(), TransformInsightsDateColumn).optional(),

  /**
   * The number of applicant rows: rows with a blank `employeeid` and a set `applicantid`.
   */
  applicantRowCount: z.number().optional(),
});

export type TransformInsights = z.infer<typeof TransformInsights>;
